import { makeStyles } from '@material-ui/core'
import formatToINR from 'src/utils/commonMethods/formatToINR'

const Coverages = ({ addonCoverageData }) => {
  const classes = useStyles()

  return (
    <>
      <div>
        <div className={classes.coveragesContainer}>
          <div className={classes.headingContainer}>
            <h2 className={classes.title}>Coverages</h2>
          </div>
          <div className={classes.listWrapper}>
            {addonCoverageData &&
              addonCoverageData?.length !== 0 &&
              addonCoverageData?.map((item) => {
                return (
                  <div
                    className={classes.listItem}
                    id='listItem'
                    key={`coverageListItem__${item?.coverage}`}
                  >
                    <div className={classes.label}>{item?.coverage}</div>
                    <div className={classes.value}>
                      {formatToINR(item?.value)}
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </>
  )
}

export default Coverages

const useStyles = makeStyles({
  coveragesContainer: {
    height: '100%',
    maxHeight: '100%',
    overflow: 'auto',
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  moreActionsIcon: {
    cursor: 'pointer',
  },
  title: {
    fontSize: '18px',
    lineHeight: '22px',
    marginTop: '20px',
    padding: '0px 24px',
    textAlign: 'center',
    color: '#333333',
  },
  listWrapper: { padding: '0px 20px' },
  listItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '16px',
    borderBottom: '1px solid #33333333',
    '&:last-child': {
      borderBottom: '0px solid #33333333',
    },
  },
  label: {
    fontSize: '13px',
    color: '#333333',
    marginBottom: '10px',
    lineHeight: '16px',
    padding: '0 10px',
  },
  value: {
    fontSize: '16px',
    color: '#B92250',
    fontWeight: 'bold',
    lineHeight: '20px',
  },
  modalRoot: {
    height: '90%',
  },
  modalContent: {
    textAlign: 'center',
    padding: '24px',
    height: 'calc(100% - 48px)',
    overflow: 'auto',
  },
})
